import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FeedbackService } from '@app/services/feedback';
import { ProgressIndicatorService } from '@app/services/progress';
import { CompanyService, ICompany } from '@services/company';
import { AppKeyService } from '@services/appkey';
import { LegalsService } from '@services/legals';

@Component({
	selector: 'app-company-overview',
	templateUrl: './company-overview.component.html',
	styleUrls: ['./company-overview.component.scss']
})
export class CompanyOverviewComponent implements OnInit, OnChanges {
	@Input() company: ICompany;

	public selectedTab = 0;
	public isAdmin = false;
	public openPanel: 'company' | 'service';

	constructor(
		private companyService: CompanyService,
		private progressIndicatorService: ProgressIndicatorService,
		private feedbackService: FeedbackService,
		private appKeyService: AppKeyService,
		private legalsService: LegalsService,
	) {}

	public ngOnInit(): void {

		this.isAdmin = this.companyService.isAdminContact();

		this.selectedTab = 0;
		this.openPanel = 'company';
	}

	public ngOnChanges(): void {
		this.isAdmin = this.companyService.isAdminContact();
	}

	public selectTab(index: number) {
		this.selectedTab = index;
	}

	public refreshCompany(): void {
		this.progressIndicatorService.spinner(true);

		this.appKeyService.clearCache();
		this.legalsService.clearCache();

		// Refresh company data, this forces all child components to refresh as needed
		this.companyService.getCompany().subscribe(
			() => {
				this.progressIndicatorService.spinner(false);
			},
			(error: any) => {
				this.feedbackService.apiError(error);
				this.progressIndicatorService.spinner(false);
			}
		);
	}
}
